require('./brokerGeoZoneBreakdown.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ local
const GeoZoneTable = require('./brokerGeoZoneBreakdownTable/brokerGeoZoneBreakdownTable');

// @ d3 components
const GeoZoneMap = require('components/d3Components/geoZoneMap/geoZoneMap');

class BrokerGeoZoneBreakdown extends React.Component {

    constructor(props) {
        super(props);
        this.setActiveRegion = this.setActiveRegion.bind(this);
        this.state = { activeRegion: -1 };
    }

    setActiveRegion(region) {
        this.setState({ activeRegion: region });
    }

    render() {
        const data = this.props.geoZoneData;

        const breakdownValues =  data ? data.getIn([0, 'BreakdownValues']) : [];

        return (
            <div className="row">
                <div className="col-xs-6">
                    <GeoZoneMap
                        width={520}
                        height={300}
                        activeRegion={this.state.activeRegion}
                        handleActiveRegionChange={this.setActiveRegion}
                    />
                </div>
                <div className="col-xs-6">
                    <GeoZoneTable
                        tableData={breakdownValues}
                        activeRegion={this.state.activeRegion}
                        handleActiveRegionChange={this.setActiveRegion}
                    />
                </div>
            </div>
        );
    }
}

BrokerGeoZoneBreakdown.propTypes = {
    geoZoneData: PropTypes.object.isRequired
};

module.exports = BrokerGeoZoneBreakdown;